<i18n>
{
"en": {
  "REASON": "Reason",
  "ABSENCEFROM": "Absence From",
  "BUSONLY": "Bus Only",
  "SELECTONEORBOTH": "Select One or Both",
  "HOMETOSCHOOL": "Home to School",
  "SCHOOLTOHOME": "School to Home",
  "MORNINGBUS": "Morning Bus",
  "AFTERNOONBUS": "Afternoon Bus",
  "MORNING": "Morning",
  "AFTERNOON": "Afternoon",
  "FROM": "From",
  "TILL": "Till",
  "SICKNESS": "Sickness",
  "VACATION": "Vacation",
  "EMERGENCY": "Emergency",
  "PERSONAL": "Personal",
  "MARKABSENCE": "Mark Absence",
  "NOMORERECORDS": "No more records",
  "ADDNEWABSENCE": "Add new absence",
  "SEARCHSTUDENTNAME": "Search student's name",
  "SCHOOL": "School",
  "CHOOSEONE": "Choose One",
  "ENTIREDAY": "Entire day",
  "EMPTYDAY": "Empty day",
  "PARTIALDAY": "Partial day",
  "DATE": "Date",
  "CANCEL": "Cancel",
  "SAVE": "Save",
  "ABSENCEISRECORDED": "Absence is saved",
  "EDITABSENCE": "Edit Absence",
  "DELETEABSENCE": "Delete Absence",
  "AREYOUSUREYOUWANTTO": "Are you sure you want to",
  "RESTORETHISABSENCE": "restore this absence?",
  "DEACTIVATETHISABSENCE": "deactivate this absence?",
  "CANCEL": "Cancel",
  "CONFIRM": "Confirm",
  "WRITEANOTE": "Write a note",
  "SUCCESSFULLYDELETED": "Successfully deleted",
  "OPERATIONFAILED": "Operation failed",
  "ADDING": "Adding",
  "UPDATING": "Updating",
  "ABSENCEON": "absence on",
  "COPIED": "Copied",
  "COPYTO": "Copy To",
  "SAVING": "Saving",
  "SUCCESSFULLYCOPIED": "Successfully copied!",
  "SELECTALL": "Select All",
  "DESELECTALL": "Deselect All",
  "ABSENCEDELETED": "Absence has been deleted!"
},
"ar": {
  "REASON": "السبب",
  "ABSENCEFROM": "غياب من",
  "BUSONLY": "من الحافلة فقط",
  "SELECTONEORBOTH": "اختر واحد أو كل منهما",
  "HOMETOSCHOOL": "المنزل إلى المدرسة",
  "SCHOOLTOHOME": "المدرسة إلى المنزل",
  "MORNINGBUS": "حافلة الصباح",
  "AFTERNOONBUS": "حافلة المساء",
  "MORNING": "الصباح",
  "AFTERNOON": "المساء",
  "FROM": "من",
  "TILL": "الى",
  "SICKNESS": "المرض",
  "VACATION": "الاجازة",
  "EMERGENCY": "حالة طوارق",
  "PERSONAL": "اسباب شخصية",
  "MARKABSENCE": " سجل غياب ",
  "NOMORERECORDS": "لا مزيد من السجلات",
  "ADDNEWABSENCE": "إضافة غياب جديد",
  "SEARCHSTUDENTNAME": " ابحث عن اسم الطالب",
  "SCHOOL": "المدرسة",
  "CHOOSEONE": "اختار واحد",
  "ENTIREDAY": " يوم كامل",
  "EMPTYDAY": "يوم فارغ",  
  "PARTIALDAY": "يوم جزئي",
  "DATE": "التاريخ",
  "CANCEL": "الغاء",
  "SAVE": " حفظ",
  "ABSENCEISRECORDED": "تم حفظ الغياب",
  "EDITABSENCE": "تحرير الغياب",
  "DELETEABSENCE": "حذف غياب",
  "AREYOUSUREYOUWANTTO": "هل أنت متأكد أنك تريد",
  "RESTORETHISABSENCE": "استعادة الغياب",
  "DEACTIVATETHISABSENCE": "تعطيل هذا الغياب",
  "CANCEL": "إلغاء",
  "CONFIRM": "تؤكد",
  "WRITEANOTE": "اكتب ملاحظة",
  "SUCCESSFULLYDELETED": "تم حذفها بنجاح",
  "OPERATIONFAILED": "فشل العملية",
  "ADDING": "اضافة",
  "UPDATING": "تحديث",
  "ABSENCEON": "غياب في",
  "COPIED": "نسخ",
  "COPYTO": "نسخ الى",
  "SAVING": "حفظ",
  "SUCCESSFULLYCOPIED": "تم نسخها بنجاح!",
  "SELECTALL": "اختر الكل",
  "DESELECTALL": "الغاء الكل",
  "ABSENCEDELETED": "تم حذف الغياب!"
}
}
</i18n>
<template>
    <el-dialog @close="clearData" id="absenceDialog" size="small" :show-close="false" :visible.sync="dialogVisible">
        <div slot="title">
          <span v-if="status" class="deleted-head"> <i class="fa fa-ban"></i> {{$t('ABSENCEDELETED')}} </span>
          <span v-else> {{$t('MARKABSENCE')}} </span>
        </div>
        <el-card class="box-card search" :body-style="{padding: (student.StudentID==undefined ? '' : 0)}" style="margin-bottom:15px" :class="[status ? 'disabled-dialog' : '']">
          <div slot="header" class="media" v-if="student.StudentID">
                <div class="media-left">
                    <img class="media-object img-circle" style="width: 80px" :src="getAsset(student.ImagePath, 'student')" />
                </div>
                <div class="media-body">
                    <h4 class="media-heading">
                        {{_FullName({NameEN: student.FullName_EN, NameAR: student.FullName_AR})}}
                        <div class="pull-right" v-show="search">
                            <i @click="clearInput" class="fa fa-2x fa-remove"></i>
                        </div><br/>
                    </h4>

                </div>
            </div>
          <div v-if="search && student.StudentID==undefined">
                  <el-autocomplete
                          v-model="searchString"
                          :fetch-suggestions="querySearch"
                          :placeholder="$t('SEARCHSTUDENTNAME')"
                          @select="addStudent"
                          icon="search"
                  >
                  </el-autocomplete>
          </div>
        </el-card>    
 
        <el-row :gutter="10" :class="[status ? 'disabled-dialog' : '']">
        <el-col :span="6">
          <el-date-picker
            type="daterange"
            size="large"
            style="width:100%"
            format="dd/MM/yyyy"
            @change="setDate"
            :disabled="absence.AbsentID!=undefined || this.student.StudentID==undefined"
            :placeholder="$t('FROM')"
            v-model="date">
          </el-date-picker>
          <el-scrollbar :viewStyle="{ height: scrollHeight + 'px', 'padding-right':4 +'px' }" ref="dateScroll">
         <div>
          <el-row :key="key" v-for="(item, key) in absences">
            <el-button-group  class="list" style="display:block;">
              <el-button :disabled="item.Deleted"  @click="absence = item" type="text" style="background-image: none" v-bind:class="{ 'text-success': !item.Deleted && absence.AbsentDate == item.AbsentDate }"><i class="fa fa-pencil"></i> {{key}}</el-button>
                  <el-popover
                   :disabled="item.AbsentID==null"
                    :ref="key"
                    trigger="click"
                    placement="right"
                    @show="absence = item"
                    width="160"
                    v-model="item.Excluded">
                    <p> {{$t('AREYOUSUREYOUWANTTO') + ' '}} {{!item.Deleted ? $t('DEACTIVATETHISABSENCE') : $t('RESTORETHISABSENCE')}}</p>
                    <el-input
                      type="textarea"
                      :placeholder="$t('WRITEANOTE')"
                      v-model="item.DeleteNote">
                      </el-input>
                    <div class="pull-right" style="margin: 0; margin-top:5px">
                      <el-button size="mini" type="text" @click="cancelPopover(key)">{{$t('CANCEL')}}</el-button>
                      <el-button type="primary" size="mini" @click="toggleStatus(key)">{{$t('CONFIRM')}}</el-button>
                    </div>
                    <el-button class="pull-right" type="text" @click="preDelete(key)" slot="reference"><i class="fa" :class="[item.Deleted ? 'fa-undo' : 'fa-times']"></i> </el-button>
                  </el-popover>                      
            </el-button-group>
          </el-row>
          </div>
        </el-scrollbar>
        </el-col>
        <el-col :span="18">
        <el-card v-if="!disableInputs" class="box-card" body-style="padding:0px" style="margin-bottom:15px">
          <div slot="header" class="clearfix" style="text-align:center">
              <span style="line-height: 25px; font-weight:bold">{{absence.AbsentID == null ? $t('ADDING') : $t('UPDATING')}} {{$t('ABSENCEON') + ' ' + date_format(absence.AbsentDate)}}</span>
          </div>              
        </el-card>          
        <el-card  style="margin-bottom:15px">
            <div slot="header" class="clearfix" style="text-align:center">
                <span style="line-height: 25px; font-weight:bold">{{$t('ABSENCEFROM')}}</span>
            </div>
            <el-row  :gutter="20">
                <el-col :span="8" style="text-align:center">
                    <el-button :disabled="disableInputs"  v-bind:class="[absence.OnlyFromBus === 0 && absence.OnlyFromBus!=null ? 'btn-active' : '']" @click="absentFrom(0)">
                        <i class="fa fa-university fa-2x"></i>
                    </el-button>
                    <h4>{{$t('SCHOOL')}}</h4>
                </el-col>

                <el-col :span="8" style="text-align:center">
                    <h4 v-if="absence.OnlyFromBus==null"><i class="fa fa-chevron-left fa-1x"></i> {{$t('CHOOSEONE')}} <i class="fa fa-chevron-right fa-1x"></i></h4>                  
                    <h4 v-else-if="absence.OnlyFromBus === 1">{{$t('BUSONLY')}}</h4>
                    <h4 v-else-if="direction[0] && direction[1] && absence.OnlyFromBus === 0">{{$t('ENTIREDAY')}}</h4>
                    <h4 v-else-if="(!direction[0] && !direction[1]) && absence.OnlyFromBus === 0">{{$t('EMPTYDAY')}}</h4>
                    <h4 v-else>{{$t('PARTIALDAY')}}</h4>
                </el-col>

                <el-col :span="8" style="text-align:center">
                    <el-button :disabled="disableInputs" v-bind:class="[absence.OnlyFromBus === 1 ? 'btn-active' : '']" v-on:click="absentFrom(1)" >
                        <i class="fa fa-bus fa-2x"></i>

                    </el-button>
                    <h4>{{$t('BUSONLY')}}</h4>
                </el-col>

            </el-row>

            <el-row  :gutter="20" class="text-center" v-if="absence.OnlyFromBus === 0 && absence.OnlyFromBus!=null"  style="min-height: 75px;">

                <el-col :span="8">
                    <el-button :disabled="disableInputs" v-on:click="busTrip(0)" v-bind:class="[absence.Trip !== 2  ? 'btn-active' : '']" style="padding: 29px 16px;">{{$t('MORNING')}}</el-button>
                </el-col>
                <el-col :span="8"  style="padding-top:20px;">

                </el-col>
                <el-col :span="8">
                    <el-button :disabled="disableInputs" v-on:click="busTrip(1)" v-bind:class="[absence.Trip !== 1 ? 'btn-active' : '']" style="padding: 29px 16px;">{{$t('AFTERNOON')}}</el-button>
                </el-col>

            </el-row>
            <el-row   class="text-center" v-if="absence.OnlyFromBus === 1 && absence.OnlyFromBus!=null" style="min-height: 75px; padding-top:10px">

                <el-col :span="7" style="padding-top:10px">

                    <el-button v-on:click="busTrip(0)" v-bind:class="[absence.Trip !== 2 ? 'btn-active' : '']">
                        <span class="morning icon" v-bind:class="[absence.Trip !== 2 ? 'activated' : '']"></span>
                        {{$t('HOMETOSCHOOL')}}</el-button>
                </el-col>

                <el-col :span="10" style="padding-top:25px">

                    <h4><i class="fa fa-chevron-left fa-1x"></i> {{$t('SELECTONEORBOTH')}} <i class="fa fa-chevron-right fa-1x"></i></h4>
                </el-col>
                <el-col :span="7" style="padding-top:10px">
                    <el-button v-on:click="busTrip(1)" v-bind:class="[absence.Trip !== 1 ? 'btn-active' : '']">
                        <span class="evening icon" v-bind:class="[absence.Trip !== 1 ? 'activated' : '']"></span>
                        {{$t('SCHOOLTOHOME')}}</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-card class="box-card absences-common" style="margin-bottom:15px">
            <div slot="header" class="clearfix" style="text-align:center">
                <span style="line-height: 25px; font-weight:bold">{{$t('REASON')}}</span>

            </div>
            <el-row  :gutter="20" style="text-align:center">
                <el-col :span="6">
                    <el-button :disabled="disableInputs" type="text" class="icon-v sickness" v-bind:class="[absence.Reason=='Sickness' ? 'activated' : '']" @click="absence.Reason='Sickness'"></el-button><br />{{$t('SICKNESS')}}
                </el-col>

                <el-col :span="6">
                    <el-button :disabled="disableInputs" type="text" class="icon-v vacation" v-bind:class="[absence.Reason=='Vacation' ? 'activated' : '']" @click="absence.Reason='Vacation'"></el-button><br />{{$t('VACATION')}}
                </el-col>

                <el-col :span="6">
                    <el-button :disabled="disableInputs" type="text" class="icon-v emergency" v-bind:class="[absence.Reason=='Emergency' ? 'activated' : '']" @click="absence.Reason='Emergency'"></el-button><br />{{$t('EMERGENCY')}}
                </el-col>

                <el-col :span="6">
                    <el-button :disabled="disableInputs" type="text" class="icon-v personal" v-bind:class="[absence.Reason=='Personal' ? 'activated' : '']" @click="absence.Reason='Personal'"></el-button><br />{{$t('PERSONAL')}}
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20" v-if="!disableInputs && !absence.Deleted && absence.Completed && nonCompletedDates.length > 0">
          <el-col :span="12">  
            <el-select ref="copyto" v-model="copied_date" @visible-change="hideTag" :placeholder="CopiedDate.length ? $t('COPIED') : $t('COPYTO')" multiple>
            <el-option
              style="padding: 0px 1px;height: 44px;"
              :key="0"
              :value="0">
              <el-button style="width: 100%;" type="primary" @click.stop="selectAll()">{{SelectAll ? $t('SELECTALL') : $t('DESELECTALL')}}</el-button>
            </el-option>              
              <el-option
                v-if="item.AbsentDate != absence.AbsentDate"
                v-for="(item, key) in nonCompletedDates"
                :key="key"
                :label="item"
                :value="item">               
              </el-option>
            </el-select>            
          </el-col>
          <el-col :span="4">
            <el-button :disabled="CopiedDate.length == 0" @click="copiesTo()">{{$t('CONFIRM')}}</el-button>
          </el-col>
        </el-row>        
        </el-col>
        </el-row>       
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t('CANCEL')}}</el-button>
          <el-button :disabled="checkUp || saving || status" type="primary" :loading="saving" @click="saveAbsence()">{{saving ? $t('SAVING') : $t('SAVE')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  import _ from 'lodash'
  export default {
    name: 'ElAbsenceDialog',
    componentName: 'ElAbsenceDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      status: {
        type: Boolean,
        default: false
      },
      search: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default: function () {
          return {AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0}
        }
      },
      selectedStudent: {
        type: Object,
        default: function () {
          return {FullName_EN: null, FullName_AR: null, ImagePath: null}
        }
      },
      serverCheck: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      dialogVisible () {
        this.updateVisible()
      },
      visible () {
        this.switchLanguage()
        this.dialogVisible = this.visible
        this.student = ''
        this.searchString = ''
        this.absence = JSON.parse(JSON.stringify(this.data))
        if (this.dialogVisible && !_.isEmpty(this.data)) this.loadAbsence()
      },
      absence: {
        handler (item) {
          let trip = item.Trip
          switch (trip) {
            case 1:
              this.direction = [true, false]
              break
            case 2:
              this.direction = [false, true]
              break
            case 3:
              this.direction = [true, true]
              break
            default: this.direction = [false, false]
          }
        },
        deep: true
      }
    },
    data () {
      return {
        dialogVisible: false,
        direction: [false, false],
        absence: {AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0},
        absences: {},
        existed_absences: {},
        date: [],
        student: {},
        searchString: '',
        message: '',
        error: false,
        saving: false,
        autoSource: null,
        completed_absences: 0,
        CopiedDate: [],
        SelectAll: true,
        scrollHeight: 305
      }
    },
    computed: {
      disableInputs () {
        if ((this.date[0] !== undefined && this.date[0] === null) || this.date.length === 0 || this.student.StudentID === undefined) return true
        return false
      },
      nonCompletedDates () {
        let emptyAbsence = {StudentID: this.student.StudentID, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0, Excluded: false, Deleted: false, Completed: false}
        let self = this
        return Object.keys(this.absences).filter(function (date) {
          if (JSON.stringify(_.omit(self.absences[date], ['AbsentID', 'AbsentDate'])) === JSON.stringify(emptyAbsence)) return date
        })
      },
      checkUp () {
        let self = this
        if (!this.doValidation() && this.completed_absences !== 0 && this.completed_absences === Object.keys(this.absences).filter(function (date) { if (!self.absences[date].Deleted) return date }).length) return false
        return true
      },
      copied_date: {
        get: function () {
          return this.CopiedDate
        },
        set: function (val) {
          if (val.indexOf(0) > -1) val.splice(val.indexOf(0), 1)
          this.CopiedDate = val
        }
      }
    },
    methods: {
      loadAbsence () {
        if (!_.isEmpty(this.absence.Direction)) {
          let icon = this.absence.Direction.icon
          switch (icon) {
            case 'morning-icon':
              this.direction = [true, false]
              this.absence.Trip = 1
              break
            case 'evening-icon':
              this.direction = [false, true]
              this.absence.Trip = 2
              break
            case 'from-bus':
              this.direction = [true, true]
              this.absence.Trip = 3
              break
          }
        }
        if (!_.isEmpty(this.absence.StudentID)) this.student = this.selectedStudent
        if (this.absence.AbsentID === null) return
        let date = this.$moment(this.absence.AbsentDate)
        let absence = this.absence
        this.absences[date.format('DD/MM/YYYY')] = absence
        this.$nextTick(function () { this.absences[date.format('DD/MM/YYYY')] = absence })
        this.existed_absences[date.format('DD/MM/YYYY')] = Object.assign({}, _.omit(absence, ['Excluded']))
        this.completed_absences++
        this.date = [date, date]
      },
      hideTag () {
        this.$refs.copyto.$el.firstChild.hidden = true
      },
      absentFrom (fromBus) {
        this.absence.OnlyFromBus = fromBus
        if (fromBus) return
        this.direction[0] = this.direction[1] = true
        this.absence.Trip = 3
      },
      busTrip (key) {
        this.direction[key] = !this.direction[key]
        if (this.direction[0] && !this.direction[1]) this.absence.Trip = 1
        if (!this.direction[0] && this.direction[1]) this.absence.Trip = 2
        if (this.direction[0] && this.direction[1]) this.absence.Trip = 3
        this.updateDirection(this.absence.Trip)
      },
      selectAll () {
        let dates = []
        if (this.SelectAll) dates = this.nonCompletedDates
        this.CopiedDate = dates
        this.SelectAll = !this.SelectAll
      },
      date_format (date) {
        if (date === null) return
        return this.$moment(date).format('DD/MM/YYYY')
      },
      updateDirection (trip) {
        if (this.absence.Direction === undefined) return
        switch (trip) {
          case 1:
            this.absence.Direction.icon = 'morning-icon'
            this.absence.Direction.title = 'MORNINGBUS'
            break
          case 2:
            this.absence.Direction.icon = 'evening-icon'
            this.absence.Direction.title = 'AFTERNOONBUS'
            break
          case 3:
            this.absence.Direction.icon = 'from-bus'
            this.absence.Direction.title = 'NOBUS'
            break
        }
      },
      updateVisible () {
        this.$emit('update:visible', this.dialogVisible)
      },
      saveAbsence () {
        let self = this
        self.saving = true
        let postData = self.filterApiData()
        this.$http.post('/absence/save', {absence: postData}).then(function (response) {
          let data = response.data
          self.saving = false
          self.dialogVisible = false
          self.message = data.message
          self.error = data.error
          if (!data.error) {
            self.$emit('update', postData)
            self.$message({message: self.$t('ABSENCEISRECORDED'), type: 'success'})
            return
          }
        }).catch(function () {
        })
      },
      copy (date) {
        if (date.length === 0) return
        let absence = Object.assign({}, this.absences[date])
        this.CopiedDate.push(date)
        absence.AbsentDate = this.absence.AbsentDate
        absence.AbsentID = null
        if (!this.absence.Completed) this.completed_absences++
        this.absences[this.$moment(absence.AbsentDate).format('DD/MM/YYYY')] = this.absence = absence
      },
      copiesTo () {
        if (this.CopiedDate.length === 0) return
        let obj = _.omit(this.absence, ['AbsentID', 'AbsentDate'])
        let self = this
        this.CopiedDate.map(function (item) {
          let source = Object.assign({}, _.pick(self.absences[item], ['AbsentID', 'AbsentDate']))
          self.completed_absences++
          self.absences[item] = Object.assign(source, obj)
        })
        this.CopiedDate = []
        this.$message({message: this.$t('SUCCESSFULLYCOPIED')})
      },
      filterApiData () {
        let self = this
        return Object.keys(this.absences).filter(function (date) {
          let Deleted = self.absences[date].Deleted
          self.absences[date] = _.omit(self.absences[date], ['Excluded'])
          for (let existed in self.existed_absences) {
            if (existed === date && JSON.stringify(self.absences[date]) !== JSON.stringify(self.existed_absences[existed])) self.absences[date].Updated = true
          }
          if (!Deleted) return date
        }).map(function (date) {
          return _.omit(self.absences[date], ['Completed', 'Deleted'])
        })
      },
      cancelPopover (key) {
        this.$refs[key][0].showPopper = false
      },
      preDelete (key) {
        this.absence = this.absences[key]
        if (this.absences[key].AbsentID === null && !this.absences[key].Deleted) {
          if (this.absence.Completed) this.completed_absences--
          return (this.absences[key].Deleted = true)
        } else if (this.absences[key].AbsentID === null && this.absences[key].Deleted) {
          if (this.absence.Completed) this.completed_absences++
          return (this.absences[key].Deleted = false)
        }
      },
      doValidation () {
        if (this.absence['Deleted']) return false
        let absence = _.pick(this.absence, ['StudentID', 'AbsentDate', 'OnlyFromBus', 'Reason'])
        for (let key in absence) {
          if (this.absence[key] === null) return true
        }
        if (!this.absence.Completed) {
          this.completed_absences++
          this.absence.Completed = true
        }
        return false
      },
      querySearch (queryString, cb) {
        let self = this
        if (self.autoSource) self.autoSource.cancel()
        let result = self.findStudent(queryString)
        result.then(function (response) {
          self.autoSource = null
          cb(!response.data ? [] : response.data)
        }).catch(function () {
        })
      },
      findStudent (queryString) {
        this.autoSource = axios.CancelToken.source()
        return this.$http.get('/student/find?term=' + queryString + '&lang=' + localStorage.getItem('lang') + '&from=absence', {cancelToken: this.autoSource.token})
      },
      addStudent (data) {
        this.student = data.student
      },
      clearInput () {
        this.clearData()
        this.dialogVisible = true
      },
      clearDates () {
        this.completed_absences = 0
        this.SelectAll = true
        this.CopiedDate = []
        this.absences = this.existed_absences = {}
        this.absence = {AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0}
        this.scrollHeight = 0
        this.$nextTick(this.$refs.dateScroll.update)
      },
      clearData () {
        Object.assign(this.$data, this.$options.data.call(this))
      },
      reportedAbsences (start) {
        if (this.disableInputs || !this.serverCheck) return
        let self = this
        this.$http.get('/absence?' + qs.stringify({filters: {minDate: this.$moment(this.date[0]).format('YYYY-MM-DD'), maxDate: this.$moment(this.date[1]).format('YYYY-MM-DD'), StudentID: this.student.StudentID}}))
          .then(function (response) {
            let absences = response.data.absences
            for (let key in absences) {
              absences[key] = _.pick(absences[key], ['AbsentID', 'StudentID', 'AbsentDate', 'Reason', 'OnlyFromBus', 'Trip', 'FromBMMA', 'Deleted'])
              let date = self.$moment(absences[key].AbsentDate).format('DD/MM/YYYY')
              absences[key].Completed = true
              self.completed_absences++
              self.existed_absences[date] = Object.assign({}, absences[key])
              self.absences[date] = absences[key]
              self.absences[date].Excluded = false
            }
            self.absence = self.absences[self.$moment(start).format('DD/MM/YYYY')]
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      setDate (value) {
        if (_.isEmpty(value)) return this.clearDates()
        if (this.dialogVisible === false) return
        if (this.disableInputs) return (this.date = [])
        let start = this.$moment(this.date[0]).format()
        let end = this.$moment(this.date[1]).format()
        let absences = {}
        for (let m = this.$moment(start); m.diff(end, 'days') <= 0; m.add(1, 'days')) {
          let date = m.format('DD/MM/YYYY')
          if (this.absences[date] === undefined && date !== undefined) {
            absences[date] = {AbsentID: null, StudentID: this.student.StudentID, AbsentDate: m.format('YYYY-MM-DD'), Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0, Excluded: false, Deleted: false, Completed: false}
          } else {
            absences[date] = Object.assign({}, this.absences[date])
          }
        }
        this.reportedAbsences(start)
        this.absences = Object.assign({}, absences)
        this.scrollHeight = 305
        this.$nextTick(this.$refs.dateScroll.update)
      },
      toggleStatus (index) {
        let postData = { AbsentID: this.absence.AbsentID, StudentID: this.absence.StudentID, DeleteNote: (this.absence.DeleteNote === null) ? '' : this.absence.DeleteNote, Status: this.absence.Deleted }
        let self = this
        this.$http.post('/absence/toggle', postData)
          .then(function (response) {
            self.$refs[index][0].showPopper = false
            self.$nextTick(function () { self.$refs[index][0].showPopper = false })
            let Deleted = !self.absence.Deleted
            self.absences[index].Deleted = Deleted
            !Deleted ? self.completed_absences++ : self.completed_absences--
            self.$message({
              message: (!response.data.error) ? 'Operation completed' : self.$t('OPERATIONFAILED'),
              type: !response.data.error ? 'success' : 'error',
              showClose: true
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  }
</script>
<style>
  #absenceDialog .el-autocomplete {width: 100%;}
  #absenceDialog textarea{border-radius: 0;  border-width: 0px; border-bottom-width: 1px}
  #absenceDialog .search .el-card__header {height: 100px}
  #absenceDialog .activated {background-color: #4b4b4b;}
  #absenceDialog .el-button.is-disabled,   #absenceDialog .el-button.is-disabled:hover,   #absenceDialog .el-button.is-disabled:focus{background-image: url('/static/img/sprite.png');}
  #absenceDialog .icon-v.el-button--text{background-image: url('/static/img/sprite.png') !important}  
  #absenceDialog .absences-common{  font-weight: bold;}
  #absenceDialog .absences-common .personal,  #absenceDialog .absences-common .personal.is-disabled {background-position: 3px -1187px}
  #absenceDialog .absences-common .vacation {background-position: -1px -1234px}
  #absenceDialog .absences-common .sickness {background-position: 2px -1269px}
  #absenceDialog .absences-common .emergency {background-position: 3px -1150px}
  #absenceDialog .absences-common .activated.personal {background-position: 3px -1517px}
  #absenceDialog .absences-common .activated.vacation {background-position: 0 -1575px}
  #absenceDialog .absences-common .activated.sickness {background-position: 1px -1624px}
  #absenceDialog .absences-common .activated.emergency {background-position: 0 -1476px}
  #absenceDialog .el-button.btn-active:hover, .el-button.btn-active:focus {color: #fff;}
  .absences-common .vacation, .absences-common .sickness, .absences-common .emergency, .absences-common .personal {
    height: 45px;
    width: 45px;
    border: 1px solid #4b4b4b;
    border-radius: 50%;
  }    
  #absenceDialog .pull-right {float: right;} 
  #absenceDialog .disabled-dialog {pointer-events: none;opacity: 0.4;}
  #absenceDialog .deleted-head {font-weight: bold;font-size: 20px;color: #ff4949;text-align: center;display: block;}
  #rtl #absenceDialog .pull-right {float: left;}
</style>



// WEBPACK FOOTER //
// Absence.vue?46303950